import useScript from 'App/hooks/useScript'

export default function(props) {
  const {id} = props
  useScript(`https://embed.tawk.to/${id}/default`, () => {})

  return null
}
